/*------------------------------------*\
    MONTH PICKER
\*------------------------------------*/
class Monthpicker {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.trigger = self.elem.querySelector('.js-monthpicker__trigger');
        self.triggerPlaceholder = self.trigger.getAttribute('data-placeholder');
        self.input = self.elem.querySelector('.js-monthpicker__input');
        self.picker = self.elem.querySelector('.js-monthpicker__picker');
        self.yearSelect = self.elem.querySelector('.js-monthpicker__year-select');
        self.clearButton = self.elem.querySelector('.js-monthpicker__clear-button');
        self.monthButtons = self.elem.querySelectorAll('.js-monthpicker__month-button');
        self.submittedYear = self.elem.getAttribute('data-submitted-year');
        self.submittedMonth = self.elem.getAttribute('data-submitted-month');
        self.selectedYear = null;
        self.selectedMonth = null;

        self.months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    }

    init() {
        let self = this;

        // If the form has been submitted and the date field was populated, populate the picker with that data
        this.populateWithSubmittedData();

        // For each month button...
        Array.from(self.monthButtons).forEach(button => {
            // When the button is clicked...
            button.addEventListener('click', evt => {
                // Clear the currently selected month
                self.clearMonths();

                // Update the input field and the trigger button text
                self.updateField(button);

                // Add selected class to clicked button
                button.classList.add('is-selected');

                // Hide the picker
                self.hidePicker();
            });
        });

        // On click of the trigger button...
        self.trigger.addEventListener('click', evt => {
            // Toggle the picker
            if(self.picker.getAttribute('aria-expanded') == 'false') {
                self.showPicker();
            }
            else {
                self.hidePicker();
            }
        });

        // On change of the year dropdown...
        self.yearSelect.addEventListener('change', evt => {
            // De-select all month buttons
            Array.from(self.monthButtons).forEach(button => {
                button.classList.remove('is-selected');
            });

            // If the selected dropdown option matches the selected year
            if(self.yearSelect.value == self.selectedYear) {
                // Highlight the selected year
                self.elem.querySelector('.js-monthpicker__month-button[data-month="' + self.selectedMonth + '"]').classList.add('is-selected');
            }
        });

        // On click of the clear button
        self.clearButton.addEventListener('click', evt => {
            // Clear the field
            self.clearField();

            // Hide the picker
            self.hidePicker();
        });
    }

    /****************************************************
    * POPULATE WITH SUBMITTED DATA
    *
    * Populate the field and picker with month and year
    * if they exist in submitted form data
    *****************************************************/
    populateWithSubmittedData() {
        let self = this;

        if(self.submittedYear.length && self.submittedMonth.length) {
            // Set the year dropdown to the submitted year
            self.yearSelect.value = self.submittedYear;

            // Select the button matching the submitted month
            self.elem.querySelector('.js-monthpicker__month-button[data-month="' + self.submittedMonth + '"]').classList.add('is-selected');

            // Update the selectedYear and selectedMonth variables with the submitted values
            self.selectedYear = self.submittedYear;
            self.selectedMonth = self.submittedMonth;

            // Populate the trigger button with the human-readable version of the date
            self.trigger.innerHTML = self.longMonth(self.submittedMonth) + ' ' + self.submittedYear;
        }
    }

    /****************************************************
    * UPDATE FIELD
    *
    * Update the field after a date has been picked
    *****************************************************/
    updateField(button) {
        let self = this;

        // Get the details of the clicked month button
        let pickedMonth = button.getAttribute('data-month');
        let pickedMonthLong = self.longMonth(pickedMonth);

        // Get the currently picked year
        let pickedYear = self.yearSelect.value;

        // Update the trigger button and input
        self.trigger.innerHTML = pickedMonthLong + ' ' + pickedYear;
        self.input.value = pickedYear + '-' + pickedMonth;

        self.updateSelected(pickedMonth, pickedYear);
    }

    /****************************************************
    * CLEAR MONTHS
    *
    * Remove selected class from all month buttons
    *****************************************************/
    clearMonths() {
        let self = this;

        // Remove selected class from all buttons
        Array.from(self.monthButtons).forEach(button => {
            button.classList.remove('is-selected');
        });
    }

    /****************************************************
    * UPDATE SELECTED
    *
    * Update the values that are stored in the JS
    * variables for month and year
    *****************************************************/
    updateSelected(month, year) {
        let self = this;

        self.selectedYear = year;
        self.selectedMonth = month;
    }

    /****************************************************
    * CLEAR FIELD
    *
    * Completely clear the field
    *****************************************************/
    clearField() {
        let self = this;

        // Remove selected class from all buttons
        Array.from(self.monthButtons).forEach(button => {
            button.classList.remove('is-selected');
        });

        // Reset the dropdown
        self.yearSelect.selectedIndex = 0;

        // Null the selectedYear/Month vars
        self.selectedYear = null;
        self.selectedMonth = null;

        // Clear the trigger button and hidden input
        self.trigger.innerHTML = self.triggerPlaceholder;
        self.input.value = '';
    }

    /****************************************************
    * SHOW PICKER
    *
    * Show the picker
    *****************************************************/
    showPicker() {
        let self = this;

        self.trigger.classList.add('is-active');
        self.picker.setAttribute('aria-expanded', true);
    }

    /****************************************************
    * HIDE PICKER
    *
    * Hide the picker
    *****************************************************/
    hidePicker() {
        let self = this;

        self.trigger.classList.remove('is-active');
        self.picker.setAttribute('aria-expanded', false);
    }

    /****************************************************
    * LONG MONTH
    *
    * Get the long version of a month from the
    * numeric version
    *****************************************************/
    longMonth(month) {
        let self = this;

        // The array is zero-indexed, so subtract 1 from the month number.
        let arrayIndex = month - 1;

        return self.months[arrayIndex];
    }
}

export default Monthpicker;
